import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service'
import { map } from 'rxjs';
import { EntityKey } from '@pma-entity/pma-entity-types';

interface GetTitleRequest {
  EntityKey: EntityKey;
  ViewName: string;
}

interface GetTitleResponse {
  Title: string;
}

@Injectable({
  providedIn: 'root'
})
export class ListerPageTitleService {

  constructor(
    private http: HttpClient,
    private readonly urlBuilderService: UrlBuilderService)
  { }

  getTitle(key: EntityKey, viewName: string): Observable<string> {
    const url = this.urlBuilderService.getUrl('title/for-entity');
    const request = <GetTitleRequest>{
      EntityKey: key,
      ViewName: viewName
    };
    return this.http.post<GetTitleResponse>(url, request).pipe(
      map(response => response?.Title || undefined));
  }
}

